import { BUSCAR_TODOS_USUARIOS_RELATORIO, LIMPAR_USUARIOS_RELATORIO } from '../../actions/types'

const initialState = [];

export default function reducerUsuariosRelatorio(state = initialState, action) {
  switch (action.type) {
    case BUSCAR_TODOS_USUARIOS_RELATORIO: {
      const usuarios = action.payload.data;
      
      if (usuarios) {
        return usuarios;
      }
      return [];
    }
    case LIMPAR_USUARIOS_RELATORIO: {
      return [];
    }
    default:
      return state;
  }
}
